import React from "react";

import { useNavigate, useParams } from "utils";

import { MainPage, Tabs } from "components";

import { SoilSightMultipleVersionOutcomes } from "pages/admin/soilSight/components/multiple/SoilSightMultipleVersionOutcomes.tsx";
import { SoilSightMultipleVersionReviews } from "pages/admin/soilSight/components/multiple/SoilSightMultipleVersionReviews.tsx";

export const SoilSightMultipleVersionPage = () => {
  const navigate = useNavigate();
  const { tab } = useParams();
  const activeTab = tab ?? "comparison";

  const tabItems = [
    { key: "comparison", label: "Version comparison", children: <SoilSightMultipleVersionOutcomes /> },
    { key: "reviews", label: "Reviews", children: <SoilSightMultipleVersionReviews /> },
  ];

  return (
    <MainPage pageName="admin" className="padding-100">
      <Tabs activeKey={activeTab} size="small" onChange={(key) => navigate(`/soil-sight-multiple-version/${key}`)} items={tabItems} />
    </MainPage>
  );
};
